import { Breadcrumbs, styled } from "@mui/material";
import { isArray } from "ramda-adjunct";
import { HTMLAttributes } from "react";
import { SearchResultIndices } from "@sinch/components/form/MultilevelSelect/types";

export const InlinedItems = ({ label }: { label: SearchResultIndices[] }) => (
  <Breadcrumbs>
    {label.map((val, index) => (
      <HightlitedLabel key={index} label={val} />
    ))}
  </Breadcrumbs>
);

const HightlitedLabel = ({ label }: { label: SearchResultIndices }) =>
  isArray(label)
    ? label.map(({ part, inRange }, i) => (inRange ? <Hightlight key={i}>{part}</Hightlight> : part))
    : label;

const Hightlight = styled("span")<HTMLAttributes<HTMLSpanElement>>(() => ({
  backgroundColor: "yellow", // TODO: MOVE TO THEME
}));
